import Chart from "chart.js";
import jQuery from "jquery";
import "./chart.plugin.watermark.js";
import { removeOverlay } from "../ui/common/utils";
// FIXME this is a work-around to TEMPORARILY get airline profile page to work that have a global dependency on jQuery
/* global $ */
window.jQuery = window.$ = jQuery;

const watermarkConfig = {
	// the image you would like to show
	// alternatively, this can be of type "Image"
	image: "/portal/gfx/ch-aviation-transparent.png",

	// // width and height to resize the image to
	// // image is not resized if these values are not set
	width: 350,
	height: 80,

	// opacity of the image, from 0 to 1 (default: 1)
	opacity: 0.2,

	// x-alignment of the image (default: "left")
	// valid values: "left", "middle", "right"
	alignX: "middle",
	// y-alignment of the image (default: "top")
	// valid values: "top", "middle", "bottom"
	alignY: "top",

	// if true, aligns the watermark to the inside of the chart area (where the lines are)
	// if false, aligns the watermark to the inside of the canvas
	// see samples/alignToChartArea.html
	alignToChartArea: true,

	// determines whether the watermark is drawn on top of or behind the chart
	// valid values: "front", "back"
	position: "front",
};

export function renderChart(
	data,
	id,
	chartType,
	legendId,
	imgElementId = null,
	maintainAspectRatio = true,
) {
	let ctx = document.getElementById(id).getContext("2d");
	let chart = new Chart(ctx, {
		type: chartType,
		data: data[0],
		options: {
			// container for watermark options
			watermark: watermarkConfig,
			legendCallback: function (chart) {
				let text = [];
				for (let i = 0; i < chart.data.datasets.length; i++) {
					text.push(
						'<button style="padding: 12px 30px 12px 30px; ' +
							"float: right;" +
							"color: white;" +
							"font-size: 12px;" +
							"border: none;" +
							"border-radius: 4px;" +
							"background-color:" +
							chart.data.datasets[i].backgroundColor[i] +
							'">',
					);
					if (chart.data.datasets[i].label) {
						text.push(chart.data.datasets[i].label);
					}
					text.push("</button>");
				}
				return text.join("");
			},
			legend: {
				display: false,
			},
			tooltips: {
				mode: "index",
				intersect: false,
			},
			responsive: true,
			maintainAspectRatio,
			scales: {
				xAxes: [
					{
						stacked: true,
						gridLines: {
							display: false,
						},
					},
				],
				yAxes: [
					{
						stacked: true,
						gridLines: {
							drawBorder: false,
						},
						ticks: {
							min: 0,
							callback: function (value, index, values) {
								this.max = values[0];
								if (Math.floor(value) === value) {
									return value;
								}
							},
						},
						afterBuildTicks: function (scale) {
							// CHA-4831 two additional horizontal lines should be added to y-axe scale, so we can place watermark in it
							let ticksContainDecimals = false;
							let currentTicks = scale.ticks.filter(
								function (tick) {
									if (tick - Math.floor(tick) !== 0) {
										ticksContainDecimals = true;
									}

									return tick - Math.floor(tick) === 0;
								},
							);
							let stepSize = currentTicks[0] - currentTicks[1];
							if (ticksContainDecimals) {
								currentTicks.unshift(
									currentTicks[0] + stepSize,
								);
							} else {
								currentTicks.unshift(
									currentTicks[0] + stepSize,
								);
								currentTicks.unshift(
									currentTicks[0] + stepSize,
								);
							}
							scale.ticks = currentTicks;
						},
					},
				],
			},
			animation: {
				onComplete: () => prepareForPrint(imgElementId, chart),
			},
		},
	});
	$("#" + legendId).prepend(chart.generateLegend());
}

window.renderChart = renderChart;

export function deleteOpenedChart() {
	$("#deliveriesModal").remove();
	removeOverlay();
}

window.deleteOpenedChart = deleteOpenedChart;

export function renderChartWithLegend(
	apiUrl,
	id,
	chartType,
	legendPosition = "bottom",
	initialChart = false,
	multipleSelectionButtonId = null,
	imgElementId = null,
	maintainAspectRatio = true,
	chartCategory = null,
	uniqueVariantsCount = 0,
) {
	let ctx = document.getElementById(id).getContext("2d");
	$.get(apiUrl).done((data) => {
		if (typeof data === "object" && Object.hasOwn(data, "datasets")) {
			let chart = new Chart(ctx, {
				type: chartType,
				data: data,
				options: {
					onClick: drillDownChart,
					// container for watermark options
					watermark: watermarkConfig,
					legend: {
						display: true,
						position: legendPosition,
						align: "left",
					},
					tooltips: {
						mode: "nearest",
						intersect: true,
						tooltipCaretSize: 0,
					},
					responsive: true,
					maintainAspectRatio,
					scales: {
						xAxes: [
							{
								barPercentage: 0.6,
								stacked: true,
								gridLines: {
									display: false,
								},
							},
						],
						yAxes: [
							{
								stacked: true,
								ticks: {
									min: 0,
									callback: function (value, index, values) {
										this.max = values[0];
										if (Math.floor(value) === value) {
											return value;
										}
									},
								},
								afterBuildTicks: function (scale) {
									// CHA-4831 two additional horizontal lines should be added to y-axe scale, so we can place watermark in it
									let ticksContainDecimals = false;
									let currentTicks = scale.ticks.filter(
										function (tick) {
											if (tick - Math.floor(tick) !== 0) {
												ticksContainDecimals = true;
											}

											return (
												tick - Math.floor(tick) === 0
											);
										},
									);
									let stepSize =
										currentTicks[0] - currentTicks[1];
									if (ticksContainDecimals) {
										currentTicks.unshift(
											currentTicks[0] + stepSize,
										);
									} else {
										currentTicks.unshift(
											currentTicks[0] + stepSize,
										);
										currentTicks.unshift(
											currentTicks[0] + stepSize,
										);
									}
									scale.ticks = currentTicks;
								},
							},
						],
					},
					animation: {
						onComplete: () => prepareForPrint(imgElementId, chart),
					},
				},
			});

			function drillDownChart(e) {
				if (uniqueVariantsCount < 50) {
					return;
				}
				let points = this.getElementsAtEventForMode(
					e,
					"nearest",
					{
						intersect: true,
					},
					true,
				);

				if (points.length === 1 && null !== chartCategory) {
					const marketGroup = points[0]._model.datasetLabel;
					const year = points[0]._model.label;
					const lastPathFragment = window.location.href
						.split("/")
						.pop();
					const chCode = lastPathFragment.substring(
						0,
						lastPathFragment.indexOf("#"),
					);
					$.get(
						"/api/v1/charts-category/" +
							chartCategory +
							"/" +
							chCode +
							"/" +
							marketGroup +
							"/" +
							year,
					).done(function (html) {
						$(".section--content").append(html);
					});
				}
			}

			if (null !== multipleSelectionButtonId) {
				$("#" + multipleSelectionButtonId).click(function () {
					let hidden = $(this).data("hidden");
					chart.data.datasets.forEach((dataset) => {
						Object.keys(dataset._meta).forEach((key) => {
							dataset._meta[key].hidden = !hidden;
						});
					});
					chart.update();
					$(this).data("hidden", !hidden);
				});
			}
		} else {
			if (initialChart) {
				// Check used aircraft, if it's empty do not display chart block
				let usedAircraftApiUrl = apiUrl.replace(
					"new-aircraft",
					"used-aircraft",
				);
				$.get(`${usedAircraftApiUrl}`).done((data) => {
					if (data.length === 0) {
						$("#" + id)
							.closest(".chart")
							.remove();
					}
				});
			} else {
				$("#" + id)
					.closest(".chart")
					.remove();
			}
		}

		const loading =
			document.getElementById(id)?.parentElement?.previousElementSibling;

		if (loading) {
			loading.classList.add("loaded");
		}
	});
}

window.renderChartWithLegend = renderChartWithLegend;

function prepareForPrint(imgElementId, chart) {
	if (!imgElementId) {
		return;
	}

	const image = $(`#${imgElementId}`);
	image.attr("src", chart.toBase64Image());
	image.addClass("chart-image-loaded");
}

function showChartDisclaimerText(spinnerId, disclaimerId) {
	const loadingSpinner = document.querySelector(spinnerId);
	const mutationCallback = (mutationsList) => {
		for (const mutation of mutationsList) {
			if (
				mutation.type === "attributes" &&
				mutation.attributeName === "class" &&
				loadingSpinner.classList.contains("loaded")
			) {
				const hiddenDisclaimer = document.querySelector(disclaimerId);
				hiddenDisclaimer?.classList.remove("hide");
			}
		}
	};
	new MutationObserver(mutationCallback).observe(loadingSpinner, {
		attributes: true,
	});
}

window.showChartDisclaimerText = showChartDisclaimerText;
